export const INCOMPLETE_NESTED_OPTION_MESSAGE = 'Choose a complete option.';
